import Vue from 'vue';

// Create a new event bus instance
export const EventBus = new Vue();

/**
 * "Someone asked to log out." App.vue owns the only correct teardown
 * (`doLogout`: revoke the server-side session, clear the identity token, reset
 * Mixpanel, re-render the login screen) and `checkLogin()` is private to it, so
 * surfaces that are not children of App's menu raise this instead of
 * re-implementing the sequence.
 *
 * Added for AS-10880: the Atlas settings sidebar reaches Warbler through
 * AtlasEmbed's PARENT_NAVIGATE bridge, which is inside `<router-view>` and so
 * cannot `$emit('logout')` up to App the way VerticalMenuBar does.
 */
export const LOGOUT_REQUESTED = 'logout-requested';
